import { render, staticRenderFns } from "./DispatchRemarkEditDialog.vue?vue&type=template&id=fbc20022&lang=pug"
import script from "./DispatchRemarkEditDialog.vue?vue&type=script&lang=js"
export * from "./DispatchRemarkEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports